import React, { useEffect, useState } from "react";
import LpForm from "../../Pages/packageDetailsPage/LpForm";
import profileImg from "../../Assets/newAsset/TestiProfile.png";
import blogBg from "../../Assets/newAsset/blogRight.jpeg";
import { BsArrowRight } from "react-icons/bs";
import { Scroll } from "../Scroll function/scroll";
import Dimer from "../../Assets/newAsset/dimer.jpg";
import "../../Pages/homePage/Components/BlogCategory.css";
import BLogBannner from "../../Assets/newAsset/blogSmall.png";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { blogsAction, getBlogDetails } from "../../Redux/Actions";
import moment from "moment";
import {
  FaLinkedinIn,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaFacebookF,
} from "react-icons/fa";
import "./BlogDetails.css";
import Meta from "../Meta";
import { useLocation } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import Loadable from "react-loadable";
import { LazyLoadImage } from "react-lazy-load-image-component";

/* Lazy load components starts */
const NewHeader = Loadable({
  loader: () => import("../NewHeader/NewHeader"),
  loading: Loader,
});

const Header = Loadable({
  loader: () => import("../Header/Header"),
  loading: Loader,
});

const Footer = Loadable({
  loader: () => import("../Footer/Footer"),
  loading: Loader,
});

const SimpleForm = Loadable({
  loader: () => import("../chatbot/SimpleForm"),
  loading: Loader,
});

const ScrolltoTop = Loadable({
  loader: () => import("../Scrolltotop/ScrolltoTop"),
  loading: Loader,
});

const Content = Loadable({
  loader: () => import("../../Pages/homePage/Components/Content"),
  loading: Loader,
});

const BlogDetails = () => {
  const { blogslug } = useParams();
  const blogdata = useSelector((state) => state.blogslist);
  const blog_detail = useSelector((state) => state.blogDetails);
  const citySelected = useSelector((state) => state.cityOnTopNav);
  // const {blogpackages} = blogdata
  const { loading: detailsloading, packages } = blog_detail;
  // const data = blogdata.blogs
  const { blogs } = blogdata;
  // console.log("blog data", blogs);
  //console.log("city selected" , citySelected)
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(blogsAction());
  }, []);
  useEffect(() => {
    dispatch(getBlogDetails(blogslug));
    Scroll();
  }, [blogslug]);

  const redirectionRule = [{
    sourceUrl:"/blog/how-and-when-to-have-cholesterol-checked",
    destinationUrl:"https://redcliffelabs.com/myhealth/food-and-nutrition/how-and-when-to-have-cholesterol-checked/"
  },{
    sourceUrl:"/blog/what-are-the-symptoms-of-vitamin-d-deficiency",
    destinationUrl:"https://redcliffelabs.com/myhealth/health/what-are-the-symptoms-of-vitamin-d-deficiency/"
  },{
    sourceUrl:"/blog/what-is-anemia-causes-symptoms-and-treatment",
    destinationUrl:"https://redcliffelabs.com/myhealth/health/what-is-anemia-causes-symptoms-and-treatment/"
  },{
    sourceUrl:"/blog/unknown-facts-on-new-variant-xe",
    destinationUrl:"https://redcliffelabs.com/myhealth/covid/unknown-facts-on-new-variant-xe/"
  },{
    sourceUrl:"/blog/ultrasound-scan-in-pregnancy",
    destinationUrl:"https://redcliffelabs.com/myhealth/health/pregnancy/ultrasound-scan-in-pregnancy/"
  },{
    sourceUrl:"/blog/medical-imaging-an-overview",
    destinationUrl:"https://redcliffelabs.com/myhealth/lab-test/medical-imaging-an-overview/"
  },{
    sourceUrl:"/blog/how-to-reduce-d-dimer-levels-in-covid-19",
    destinationUrl:"/myhealth/covid/how-to-reduce-d-dimer-levels-in-covid-19/"
  },{
    sourceUrl:"/blog/dengue-fever-and-its-symptoms",
    destinationUrl:"https://redcliffelabs.com/myhealth/health/dengue-fever-and-its-symptoms/"
  },{
    sourceUrl:"/blog/everything-you-need-to-know-about-omicron-variant",
    destinationUrl:"https://redcliffelabs.com/myhealth/covid/everything-you-need-to-know-about-omicron-variant/"
  },{
    sourceUrl:"/blog/signs-and-symptoms-of-vitamin-b12-deficiency",
    destinationUrl:"https://redcliffelabs.com/myhealth/lifestyle/overall-health/signs-and-symptoms-of-vitamin-b12-deficiency/"
  },{
    sourceUrl:"/blog/how-does-dengue-fever-spread",
    destinationUrl:"https://redcliffelabs.com/myhealth/health/how-does-dengue-fever-spread/"
  },{
    sourceUrl:"/blog/how-does-a-full-body-checkup-keep-you-safe",
    destinationUrl:"https://redcliffelabs.com/myhealth/lifestyle/overall-health/how-does-a-full-body-checkup-keep-you-safe/"
  },{
    sourceUrl:"/blog/9-reasons-to-get-full-body-checkup-now",
    destinationUrl:"https://redcliffelabs.com/myhealth/lab-test/9-reasons-to-get-full-body-checkup-now/"
  }]

  useEffect(() => {

    redirectionRule.forEach((item => {
      if(item?.sourceUrl == location?.pathname){
        window.location.href = item?.destinationUrl
        return
      } 
    }))

  }, [])
  

  //for OG TAGS DATA
  if (packages && packages?.og_tag) {
    try {
      if (packages?.og_tag) {
        var OgObject = JSON.parse(packages.og_tag);

        console.log(OgObject, "og tag object");
      } else {
        var OgObject = false;
      }
    } catch (error) {
      console.log(error, "error from OG_TAG");
    }

    // var recommndedPackage = packDetail.related_packages;
  }

  //for twitter_card DATA
  if (packages && packages?.twitter_card) {
    try {
      if (packages?.twitter_card) {
        var twCard = JSON.parse(packages.twitter_card);

        // console.log(twCard, "og tag twCard");
      } else {
        var twCard = false;
      }
    } catch (error) {
      console.log(error, "error from twCard");
    }

    // var recommndedPackage = packDetail.related_packages;
  }
  return (
    <React.Fragment>
      {packages ? (
        <Meta
          title={packages && packages.meta_title}
          description={packages.meta_description}
          keywords={packages.meta_keyword && packages.meta_keyword}
        >
          {/* <meta property="robots" content={Og.robots ? Og.robots : ""} /> */}
          <meta property="og:title" content={OgObject?.title} />
          <meta property="og:site_name" content={OgObject?.site_name} />
          <meta property="og:url" content={OgObject?.url} />
          <meta property="og:description" content={OgObject?.description} />
          <meta property="og:type" content={OgObject?.type} />
          <meta property="og:image" content={OgObject?.image} />
          {/* {scratch_codeData ? (
              <script type="application/ld+json">{scratch_codeData}</script>
            ) : null} */}
          <meta name="twitter:card" content={twCard ? twCard.card : ""} />
          <meta name="twitter:site" content={twCard ? twCard.site : ""} />
          <meta name="twitter:title" content={twCard ? twCard.title : ""} />
          <meta
            name="twitter:description"
            content={twCard ? twCard.description : ""}
          />
          <meta name="twitter:image" content={twCard ? twCard.image : ""} />
        </Meta>
      ) : null}

      <NewHeader />
      <div className="blogDetails">
        <div className="blogMainHeading">
          <h1>Blogs</h1>
        </div>
        <div className="blog_detailParent">
          {detailsloading ? (
            "loading"
          ) : (
            <div
              className="content_Blog"
              dangerouslySetInnerHTML={{
                __html: `${packages.content}`,
              }}
            ></div>
          )}

          <div className="BlogSection2">
            <div className="Div__1">
              <Link
                to={`/smart-full-body-checkup${
                citySelected?.citySelect
                  ? `-${citySelected?.citySelect
                      .toLowerCase()
                      .replace(" ", "-")}`
                  : ""
              }`}
                style={{ cursor: "pointer", width: "100%" }}
              >
                <div>
                  <span>Health Check-ups Starts at</span>
                  <h2>Rs. 699/-</h2>
                </div>
                <span>Book Consultation</span>
              </Link>
            </div>
            <div className="Div__2">
              <LpForm
                butname={"SUBMIT"}
                title={"Book Your Test"}
                position={"Banner"}
              />
            </div>
            <div className="Div__3">
              <div className="Recom_heading">
                <h2> Recommended Articles</h2>
              </div>
              {blogs &&
                blogs.results &&
                blogs.results.map((values, index) => {
                  if (index < 5) {
                    return (
                      <div className="RecomDiv" key={values.id}>
                        <div className="Recom_img">
                          {" "}
                          <LazyLoadImage
                            src={values.image}
                            alt={values.image}
                            delayTime="100"
                          />
                        </div>
                        <div className="Recom_desc">
                          <p className="Recom_date">
                            {moment(values.created_at).format("Do MMM  YYYY")}
                          </p>
                          <p className="Recom_title">
                            {" "}
                            <Link
                              className="Blog__title"
                              to={`/blog/${values.slug}`}
                            >
                              {values.blog_name}
                            </Link>
                          </p>
                          <div className="Recom_readmore">
                            <Link to={`/blog/${values.slug}`}>Read more</Link>
                            <BsArrowRight />
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
            </div>
            <div className="Div__4">
              <h2> Follow Us On</h2>
              <div className="socialIcons">
                <a
                  target="_blank"
                  href="https://www.instagram.com/redcliffelabs/"
                >
                  {" "}
                  <FaInstagram
                    fontSize="2.5rem"
                    className="social_icon_design"
                  />{" "}
                </a>
                <a
                  target="_blank"
                  href="https://www.facebook.com/RedcliffeLabs/"
                >
                  {" "}
                  <FaFacebookF
                    fontSize="2.5rem"
                    className="social_icon_design"
                  />
                </a>
                <a target="_blank" href="https://twitter.com/redcliffelab">
                  {" "}
                  <FaTwitter fontSize="2.5rem" className="social_icon_design" />
                </a>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/redcliffe-labs/"
                >
                  {" "}
                  <FaLinkedinIn
                    fontSize="2.5rem"
                    className="social_icon_design"
                  />
                </a>
                <a
                  target="_blank"
                  href="https://www.youtube.com/c/RedcliffeLabs"
                >
                  {" "}
                  <FaYoutube fontSize="2.5rem" className="social_icon_design" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="blogDisclaimerDiv">
        <span> Disclaimer:</span>
        <p>
          The blog content has been posted as a piece of information and
          awareness only. The content provided in this blog, or in any linked
          materials, are not proposed and should not be taken as medical advice.
          Redcliffe Labs strongly recommends users to consult with their health
          care providers to make any medical or health-related decision.
        </p>
      </div>
      <Content Ispackage={true} />
      <ScrolltoTop />
      <Footer />
      <div className="chatbot">
        <SimpleForm />
      </div>
    </React.Fragment>
  );
};

export default {
  component: BlogDetails,
};
